import "./Directors.css";
import img1 from "../assets/dir-img1.png";
import img2 from "../assets/dir-img2.png";
import img3 from "../assets/dir-img3.png";
import img4 from "../assets/dir-img4VV.jpg";
import img5 from "../assets/dir-img5.png";
import img6 from "../assets/dir-img6.png";
import img7 from "../assets/dir-img7.png";
import Footer from "./Footer";
import { useNavigate } from "react-router-dom";

const directors = [
  {
    name: "Mr. Venu Srinivasan",
    role: "Chairman",
    img: img1,
    slug: "venu-srinivasan",
  },
  {
    name: "Dr. Lakshmi Venu",
    role: "Managing Director",
    img: img3,
    slug: "lakshmi-venu",
  },
  {
    name: "Mr. R. Venkatesh",
    role: "Director & Chief Executive Officer",
    img: img4,
    slug: "r-venkatesh",
  },
  {
    name: "Mr. R. Gopalan",
    role: "Independent Director",
    img: img2,
    slug: "r-gopalan",
  },
  {
    name: "Mr. C. R. Dua",
    role: "Independent Director",
    img: img5,
    slug: "cr-dua",
  },
  {
    name: "Ms. Sasikala Varadachari",
    role: "Independent Director",
    img: img6,
    slug: "sasikala-varadachari",
  },
  {
    name: "Mr. R. Anandakrishnan",
    role: "Non-Executive Director",
    img: img7,
    slug: "anandakrishnan",
  },
  
];

export default function BoardOfDirectors() {
  const navigate = useNavigate();

  return (
    <section id="directors">
      <div className="board-container-1">
        <h1 className="board-title-1">Board of Directors</h1>
        <div className="dir-underline"></div>

        <div className="bod-wrapper">
          <div className="bod-grid">
            {directors.map((d, i) => (
              <div className="bod-card" key={i}>
                <div className={`bod-image ${!d.img ? "placeholder" : ""}`}>
                  {d.img && <img src={d.img} alt={d.name} />}
                </div>

                <div className="bod-info">
                  <div>
                    <p className="bod-name">{d.name}</p>
                    <p className="bod-role">{d.role}</p>
                  </div>
                  <span
                    className="bod-arrow"
                    onClick={() => navigate(`/director/${d.slug}`)} id="dir-pg"
                  >
                    →
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </section>
  );
}
